import { useMemo } from 'react'
import { FormControl, MenuItem, Select, Skeleton, Stack, Typography } from '@mui/material'
import ModalDashboardSettingComponent from '../../modal-dashboard/ModalDashboardSettingComponent'
import { DISPLAY_TASK_COLUMNS, SUMMARY_TYPES } from '../utils/constant'
import { useTranslation } from 'react-i18next'
import { useJobActivityViewQuery } from '../../job-summary/helper/reducers/jobAcitivityViewQuery'
import { DISPLAY_COLUMNS } from '../../job-summary/helper/constant'
import { useSummaryDefaultProjectFormInfo } from '../utils/hooks/summaryHeaderQuery'
import { TASK_MAP_SETTING_TYPES } from '../utils/constant'
import PlottingMapForm from '../../plotting-map/PlottingMapForm'

function TaskSummaryForm({ filterData, onFilterDataChange, tileType }) {
	const [t] = useTranslation()
	const { selectedJobActivityForm, projectLoading } = useSummaryDefaultProjectFormInfo({
		summaryType: SUMMARY_TYPES.TASK,
	})
	const { allColumns: taskAllColumns, viewLoading: taskViewLoading } = useJobActivityViewQuery({
		formKey: selectedJobActivityForm?.formKey,
		projectKey: selectedJobActivityForm?.projectKey,
	})

	const displayTaskColumns = useMemo(() => {
		return taskAllColumns
			.filter((column) => DISPLAY_TASK_COLUMNS.includes(column.name))
			.map((column) => ({
				...column,
				title: DISPLAY_COLUMNS[column.name] || column.title,
			}))
	}, [taskAllColumns])
	return (
		<Stack spacing={2}>
			{projectLoading || taskViewLoading ? (
				<Skeleton variant="rectangular" height={180} sx={{ mb: 1 }} />
			) : (
				<>
					<FormControl variant="outlined" size="small" sx={{ minWidth: '100px' }}>
						<Typography variant="subtitle2" sx={{ pl: 1 }}>
							{t('common:input.progressField')}
						</Typography>
						<Select
							value={filterData?.progressBarField || ''}
							onChange={(e) => {
								const newValue = e.target.value
								onFilterDataChange('progressBarField', newValue)
							}}
							size="small"
							fullWidth
						>
							<MenuItem value="">
								<em>None</em>
							</MenuItem>
							{displayTaskColumns.map((col) => (
								<MenuItem value={col.name}>{col.title}</MenuItem>
							))}
						</Select>
					</FormControl>
					{/* <FormControl variant="outlined" size="small" sx={{ mr: '5px', minWidth: '80px' }}>
						<Typography variant="subtitle2" sx={{ pl: 1 }}>
							{t('common:input.filterField')}
						</Typography>
						<Select
							value={filterData?.filterField || ''}
							onChange={(e) => {
								const newValue = e.target.value
								onFilterDataChange('filterField', newValue)
							}}
							size="small"
						>
							<MenuItem value="">
								<em>None</em>
							</MenuItem>
							{displayTaskColumns.map((col) => (
								<MenuItem value={col.name}>{col.title}</MenuItem>
							))}
						</Select>
					</FormControl> */}
				</>
			)}
			<ModalDashboardSettingComponent
				setting={filterData?.modalDashboardSetting}
				onChangeSetting={(value) => {
					onFilterDataChange('modalDashboardSetting', value)
				}}
				dataFields={displayTaskColumns}
			/>
			<PlottingMapForm
				filterData={filterData}
				handleFilterDataChange={onFilterDataChange}
				taskMapSettingType={TASK_MAP_SETTING_TYPES.ALL}
				tileType={tileType}
			/>
		</Stack>
	)
}

export default TaskSummaryForm
